import * as i0 from '@angular/core';
import { InjectionToken, ElementRef, Optional, Component, ChangeDetectionStrategy, Inject, HostBinding, EventEmitter, Directive, Input, Output, HostListener, NgZone, ChangeDetectorRef, ContentChildren, forwardRef, TemplateRef, ViewChild, NgModule } from '@angular/core';
import * as i2 from '@angular/router';
import { RouterLinkActive } from '@angular/router';
import * as i4 from '@taiga-ui/cdk';
import { TuiDestroyService, TuiFocusVisibleService, tuiTypedFromEvent, tuiIsNativeFocused, tuiMoveFocus, tuiCreateToken, tuiProvideOptions, tuiZonefree, EMPTY_QUERY, TuiResizeService, tuiPure, tuiClamp, tuiIsElement, tuiGetClosestFocusable, tuiToInt, TuiItemDirective, TuiFocusableModule, TuiItemModule } from '@taiga-ui/cdk';
import * as i2$1 from '@taiga-ui/core';
import { TuiRouterLinkActiveService, MODE_PROVIDER, TUI_MODE, tuiDropdownOptionsProvider, TuiHostedDropdownModule, TuiSvgModule } from '@taiga-ui/core';
import { TUI_TAB_MARGIN, TUI_MORE_WORD } from '@taiga-ui/kit/tokens';
import { MutationObserverService, MUTATION_OBSERVER_INIT } from '@ng-web-apis/mutation-observer';
import * as i3 from 'rxjs';
import { EMPTY, merge, identity, ReplaySubject, of } from 'rxjs';
import { filter, map, switchMap, share, debounceTime, tap, startWith, takeUntil } from 'rxjs/operators';
import * as i5 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i8 from '@tinkoff/ng-polymorpheus';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
import { __decorate } from 'tslib';
import { ANIMATION_FRAME } from '@ng-web-apis/common';
import { asCallable } from '@tinkoff/ng-event-plugins';
import { TUI_ARROW_OPTIONS } from '@taiga-ui/kit/components/arrow';

/**
 * Stream of tab activation events
 */
const _c0 = ["tuiTab", ""];
function TuiTabComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
const _c1 = ["*"];
function TuiTabsComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TuiTabsComponent_tui_underline_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-underline", 2);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("element", ctx_r1.activeElement);
  }
}
const _c2 = ["vertical", ""];
function TuiTabsWithMoreComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TuiTabsWithMoreComponent_ng_container_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 12);
  }
  if (rf & 2) {
    const item_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngTemplateOutlet", item_r8);
  }
}
function TuiTabsWithMoreComponent_ng_container_4_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementContainer(1, 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    const index_r9 = ctx_r14.index;
    const item_r8 = ctx_r14.$implicit;
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("t-overflown", ctx_r11.isOverflown(index_r9));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", item_r8);
  }
}
function TuiTabsWithMoreComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TuiTabsWithMoreComponent_ng_container_4_ng_container_1_Template, 1, 1, "ng-container", 10)(2, TuiTabsWithMoreComponent_ng_container_4_ng_template_2_Template, 2, 3, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const index_r9 = ctx.index;
    const _r12 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", index_r9 <= ctx_r1.lastVisibleIndex)("ngIfElse", _r12);
  }
}
function TuiTabsWithMoreComponent_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const text_r15 = ctx.polymorpheusOutlet;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", text_r15, " ");
  }
}
function TuiTabsWithMoreComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵelement(2, "tui-svg", 13);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 4, ctx_r3.moreWord$), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("t-icon_rotated", ctx_r3.open);
    i0.ɵɵproperty("src", ctx_r3.arrowOptions.iconSmall);
  }
}
function TuiTabsWithMoreComponent_ng_template_10_div_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 12);
  }
  if (rf & 2) {
    const item_r18 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngTemplateOutlet", item_r18);
  }
}
function TuiTabsWithMoreComponent_ng_template_10_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵlistener("tui-tab-activate", function TuiTabsWithMoreComponent_ng_template_10_div_2_Template_div_tui_tab_activate_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r23);
      const index_r19 = restoredCtx.index;
      const ctx_r22 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r22.onClick(index_r19));
    });
    i0.ɵɵtemplate(1, TuiTabsWithMoreComponent_ng_template_10_div_2_ng_container_1_Template, 1, 1, "ng-container", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const index_r19 = ctx.index;
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r17.shouldShow(index_r19));
  }
}
function TuiTabsWithMoreComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14, 15);
    i0.ɵɵlistener("keydown.arrowDown.prevent", function TuiTabsWithMoreComponent_ng_template_10_Template_div_keydown_arrowDown_prevent_0_listener($event) {
      i0.ɵɵrestoreView(_r25);
      const _r16 = i0.ɵɵreference(1);
      const ctx_r24 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r24.onWrapperArrow($event, _r16, false));
    })("keydown.arrowUp.prevent", function TuiTabsWithMoreComponent_ng_template_10_Template_div_keydown_arrowUp_prevent_0_listener($event) {
      i0.ɵɵrestoreView(_r25);
      const _r16 = i0.ɵɵreference(1);
      const ctx_r26 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r26.onWrapperArrow($event, _r16, true));
    });
    i0.ɵɵtemplate(2, TuiTabsWithMoreComponent_ng_template_10_div_2_Template, 2, 1, "div", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r5.items);
  }
}
function TuiTabsWithMoreComponent_tui_underline_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-underline", 19);
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("element", ctx_r7.activeElement);
  }
}
const TUI_TAB_EVENT = new InjectionToken(`[TUI_TAB_EVENT]`);
const TUI_TAB_ACTIVATE = `tui-tab-activate`;
const TUI_TAB_PROVIDERS = [TuiDestroyService, TuiFocusVisibleService, TuiRouterLinkActiveService, {
  provide: TUI_TAB_EVENT,
  deps: [ElementRef, TuiRouterLinkActiveService, [new Optional(), MutationObserverService], [new Optional(), RouterLinkActive]],
  useFactory: ({
    nativeElement
  }, routerLinkActiveService, mutationObserverService, routerLinkActive) => {
    const mutationObserver = routerLinkActive && mutationObserverService ? mutationObserverService.pipe(filter(() => routerLinkActive.isActive)) : EMPTY;
    return merge(mutationObserver, routerLinkActiveService.pipe(filter(identity)), nativeElement.matches(`button`) ? tuiTypedFromEvent(nativeElement, `click`) : EMPTY).pipe(map(() => nativeElement.dispatchEvent(new CustomEvent(TUI_TAB_ACTIVATE, {
      bubbles: true
    }))));
  }
}, MODE_PROVIDER];
let TuiTabComponent = /*#__PURE__*/(() => {
  class TuiTabComponent {
    constructor(routerLinkActive, el, mode$, event$, margin, focusVisible$) {
      this.routerLinkActive = routerLinkActive;
      this.el = el;
      this.mode$ = mode$;
      this.event$ = event$;
      this.margin = margin;
      this.focusVisible = false;
      focusVisible$.subscribe(visible => {
        this.focusVisible = visible;
      });
    }
    get isActive() {
      return !!this.routerLinkActive && this.routerLinkActive.isActive;
    }
    ngOnDestroy() {
      if (tuiIsNativeFocused(this.el.nativeElement)) {
        this.el.nativeElement.blur();
      }
    }
  }
  TuiTabComponent.ɵfac = function TuiTabComponent_Factory(t) {
    return new (t || TuiTabComponent)(i0.ɵɵdirectiveInject(RouterLinkActive, 8), i0.ɵɵdirectiveInject(ElementRef), i0.ɵɵdirectiveInject(TUI_MODE), i0.ɵɵdirectiveInject(TUI_TAB_EVENT), i0.ɵɵdirectiveInject(TUI_TAB_MARGIN), i0.ɵɵdirectiveInject(TuiFocusVisibleService));
  };
  TuiTabComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TuiTabComponent,
    selectors: [["a", "tuiTab", "", 3, "routerLink", ""], ["a", "tuiTab", "", "routerLink", "", "routerLinkActive", ""], ["button", "tuiTab", ""]],
    hostAttrs: ["type", "button"],
    hostVars: 8,
    hostBindings: function TuiTabComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("$.data-mode.attr", function TuiTabComponent___data_mode_attr_HostBindingHandler() {
          return ctx.mode$;
        });
      }
      if (rf & 2) {
        i0.ɵɵstyleProp("cursor", "pointer")("--tui-tab-margin", ctx.margin, "px");
        i0.ɵɵclassProp("_focus-visible", ctx.focusVisible)("_active", ctx.isActive);
      }
    },
    features: [i0.ɵɵProvidersFeature(TUI_TAB_PROVIDERS)],
    attrs: _c0,
    ngContentSelectors: _c1,
    decls: 4,
    vars: 3,
    consts: [[4, "ngIf"], [1, "t-highlight"]],
    template: function TuiTabComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, TuiTabComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵelementStart(2, "span", 1);
        i0.ɵɵprojection(3);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.event$));
      }
    },
    dependencies: [i5.NgIf, i5.AsyncPipe],
    styles: ["._underline[_nghost-%COMP%]:hover, ._underline   [_nghost-%COMP%]:hover{box-shadow:inset 0 -2px var(--tui-base-03)}tui-tabs    > [_nghost-%COMP%]:first-child, tui-tabs    > [_nghost-%COMP%]:first-child, [tuiTabs]    > [_nghost-%COMP%]:first-child, [tuiTabs]    > [_nghost-%COMP%]:first-child, tui-tabs    > :first-child[_nghost-%COMP%], tui-tabs    > :first-child   [_nghost-%COMP%], [tuiTabs]    > :first-child[_nghost-%COMP%], [tuiTabs]    > :first-child   [_nghost-%COMP%]{margin-left:0}[_nghost-%COMP%]{transition-property:color,box-shadow,opacity,background;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0;border:0;background:none;font-size:inherit;line-height:inherit;position:relative;display:flex;flex-shrink:0;height:100%;box-sizing:border-box;justify-content:space-between;align-items:center;white-space:nowrap;cursor:pointer;outline:none;text-decoration:none;color:inherit;margin-left:var(--tui-tab-margin, 1.5rem)}[_nghost-%COMP%]:disabled{opacity:var(--tui-disabled-opacity);pointer-events:none}[_nghost-%COMP%]:not([data-mode])._active{opacity:1;color:var(--tui-text-01);box-shadow:none}[data-mode=onDark][_nghost-%COMP%]{color:#ffffffb8}[data-mode=onDark][_nghost-%COMP%]:hover, [data-mode=onDark]._active[_nghost-%COMP%]{color:#fff}[data-mode=onDark]._focus-visible[_nghost-%COMP%]   .t-highlight[_ngcontent-%COMP%]{background:var(--tui-clear-inverse);color:var(--tui-text-01)}[data-mode=onLight][_nghost-%COMP%]{color:var(--tui-text-02)}[data-mode=onLight][_nghost-%COMP%]:hover, [data-mode=onLight]._active[_nghost-%COMP%]{color:var(--tui-text-01)}[data-mode=onLight]._focus-visible[_nghost-%COMP%]   .t-highlight[_ngcontent-%COMP%]{background:var(--tui-text-01);color:#fff}._focus-visible[_nghost-%COMP%]   .t-highlight[_ngcontent-%COMP%]{background:var(--tui-selection)}._android[_nghost-%COMP%]{transition-property:opacity;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;height:3rem;flex:1;flex-shrink:0;justify-content:center;margin:0;text-transform:uppercase;color:var(--tui-base-09);opacity:.5;font-size:.875rem;font-weight:500;letter-spacing:-.008125rem;font-family:-apple-system,BlinkMacSystemFont,Roboto,\"Helvetica Neue\",sans-serif}._android[_nghost-%COMP%]:hover{box-shadow:none}._android._active[_nghost-%COMP%]{opacity:1;color:var(--tui-base-09)}._android[_nghost-%COMP%]   .t-highlight[_ngcontent-%COMP%]{width:auto}._ios[_nghost-%COMP%]{height:1.75rem;flex:1;flex-shrink:0;justify-content:center;margin:0;color:var(--tui-base-01);opacity:1;font-size:.8125rem;font-weight:500;letter-spacing:-.005rem;font-family:-apple-system,BlinkMacSystemFont,Roboto,\"Helvetica Neue\",sans-serif}._ios[_nghost-%COMP%]:hover{box-shadow:none}._ios._active[_nghost-%COMP%]{font-size:.875rem;font-weight:600;color:var(--tui-link)}._ios[_nghost-%COMP%]   .t-highlight[_ngcontent-%COMP%]{width:auto}@media (hover: hover){[_nghost-%COMP%]:hover{color:var(--tui-text-01)}}.t-highlight[_ngcontent-%COMP%]{display:inline-flex;width:100%;align-items:center;justify-content:inherit}.t-highlight[_ngcontent-%COMP%]    >*{flex-shrink:0}tui-tabs[data-vertical][_nghost-%COMP%], tui-tabs[data-vertical]   [_nghost-%COMP%], [tuiTabs][data-vertical][_nghost-%COMP%], [tuiTabs][data-vertical]   [_nghost-%COMP%]{min-height:2.75rem;height:auto;white-space:normal;margin:0;text-align:left;padding:.25rem 1.25rem .25rem 0}tui-tabs[data-vertical][_nghost-%COMP%]:after, tui-tabs[data-vertical]   [_nghost-%COMP%]:after, [tuiTabs][data-vertical][_nghost-%COMP%]:after, [tuiTabs][data-vertical]   [_nghost-%COMP%]:after{transition-property:transform;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;content:\"\";position:absolute;top:0;bottom:0;right:0;width:2px;background:var(--tui-primary);transform:scaleX(0);transform-origin:right}tui-tabs[data-vertical][_nghost-%COMP%]:hover, tui-tabs[data-vertical]   [_nghost-%COMP%]:hover, [tuiTabs][data-vertical][_nghost-%COMP%]:hover, [tuiTabs][data-vertical]   [_nghost-%COMP%]:hover{box-shadow:inset -2px 0 var(--tui-base-03)}tui-tabs[data-vertical]._active[_nghost-%COMP%]:after, tui-tabs[data-vertical]   ._active[_nghost-%COMP%]:after, [tuiTabs][data-vertical]._active[_nghost-%COMP%]:after, [tuiTabs][data-vertical]   ._active[_nghost-%COMP%]:after{transform:none}tui-tabs[data-vertical=\"right\"][_nghost-%COMP%], tui-tabs[data-vertical=\"right\"]   [_nghost-%COMP%], [tuiTabs][data-vertical=\"right\"][_nghost-%COMP%], [tuiTabs][data-vertical=\"right\"]   [_nghost-%COMP%]{text-align:right;padding:.25rem 0 .25rem 1.25rem}tui-tabs[data-vertical=\"right\"][_nghost-%COMP%]:after, tui-tabs[data-vertical=\"right\"]   [_nghost-%COMP%]:after, [tuiTabs][data-vertical=\"right\"][_nghost-%COMP%]:after, [tuiTabs][data-vertical=\"right\"]   [_nghost-%COMP%]:after{right:auto;left:0;transform-origin:left}tui-tabs[data-vertical=\"right\"][_nghost-%COMP%]:hover, tui-tabs[data-vertical=\"right\"]   [_nghost-%COMP%]:hover, [tuiTabs][data-vertical=\"right\"][_nghost-%COMP%]:hover, [tuiTabs][data-vertical=\"right\"]   [_nghost-%COMP%]:hover{box-shadow:inset 2px 0 var(--tui-base-03)}"],
    changeDetection: 0
  });
  return TuiTabComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiTabsDirective = /*#__PURE__*/(() => {
  class TuiTabsDirective {
    constructor(el) {
      this.el = el;
      this.activeItemIndex = 0;
      this.activeItemIndexChange = new EventEmitter();
    }
    get tabs() {
      return Array.from(this.el.nativeElement.querySelectorAll('[tuiTab]'));
    }
    get activeElement() {
      return this.tabs[this.activeItemIndex] || null;
    }
    onActivate(event, element) {
      const index = this.tabs.findIndex(tab => tab === element);
      event.stopPropagation();
      if (index === this.activeItemIndex) {
        return;
      }
      this.activeItemIndexChange.emit(index);
      this.activeItemIndex = index;
    }
    moveFocus(current, step) {
      const {
        tabs
      } = this;
      tuiMoveFocus(tabs.indexOf(current), tabs, step);
    }
    ngAfterViewChecked() {
      const {
        tabs,
        activeElement
      } = this;
      tabs.forEach(nativeElement => {
        const active = nativeElement === activeElement;
        nativeElement.classList.toggle('_active', active);
        nativeElement.setAttribute('tabIndex', active ? '0' : '-1');
      });
    }
  }
  TuiTabsDirective.ɵfac = function TuiTabsDirective_Factory(t) {
    return new (t || TuiTabsDirective)(i0.ɵɵdirectiveInject(ElementRef));
  };
  TuiTabsDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TuiTabsDirective,
    selectors: [["tui-tabs"], ["nav", "tuiTabs", ""]],
    hostBindings: function TuiTabsDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("tui-tab-activate", function TuiTabsDirective_tui_tab_activate_HostBindingHandler($event) {
          return ctx.onActivate($event, $event.target);
        });
      }
    },
    inputs: {
      activeItemIndex: "activeItemIndex"
    },
    outputs: {
      activeItemIndexChange: "activeItemIndexChange"
    }
  });
  return TuiTabsDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const TUI_TABS_DEFAULT_OPTIONS = {
  underline: true,
  exposeActive: true,
  itemsLimit: Infinity,
  minMoreWidth: 0
};
/**
 * Default parameters for Tabs component
 */
const TUI_TABS_OPTIONS = tuiCreateToken(TUI_TABS_DEFAULT_OPTIONS);
function tuiTabsOptionsProvider(options) {
  return tuiProvideOptions(TUI_TABS_OPTIONS, options, TUI_TABS_DEFAULT_OPTIONS);
}
let TuiUnderlineComponent = /*#__PURE__*/(() => {
  class TuiUnderlineComponent {
    constructor({
      nativeElement
    }, zone, animationFrame$, mode$) {
      this.zone = zone;
      this.animationFrame$ = animationFrame$;
      this.mode$ = mode$;
      this.el$ = new ReplaySubject(1);
      this.refresh$ = this.el$.pipe(switchMap(element => element ? this.animationFrame$.pipe(map(() => element), tuiZonefree(this.zone)) : of(null)), share());
      this.transition$ = asCallable(this.el$.pipe(map(element => element && 'all'), debounceTime(50)));
      this.transform$ = asCallable(this.refresh$.pipe(map(element => element ? `translate3d(${element.offsetLeft}px, 0, 0)` : null)));
      this.width$ = asCallable(this.refresh$.pipe(map(element => (element === null || element === void 0 ? void 0 : element.clientWidth) || 0)));
      nativeElement['$.style.transitionProperty'] = this.transition$;
      nativeElement['$.style.transform'] = this.transform$;
      nativeElement['$.style.width.px'] = this.width$;
    }
    set element(element) {
      this.el$.next(element);
    }
  }
  TuiUnderlineComponent.ɵfac = function TuiUnderlineComponent_Factory(t) {
    return new (t || TuiUnderlineComponent)(i0.ɵɵdirectiveInject(ElementRef), i0.ɵɵdirectiveInject(NgZone), i0.ɵɵdirectiveInject(ANIMATION_FRAME), i0.ɵɵdirectiveInject(TUI_MODE));
  };
  TuiUnderlineComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TuiUnderlineComponent,
    selectors: [["tui-underline"]],
    hostBindings: function TuiUnderlineComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("$.data-mode.attr", function TuiUnderlineComponent___data_mode_attr_HostBindingHandler() {
          return ctx.mode$;
        })("$.style.transitionProperty", function TuiUnderlineComponent___style_transitionProperty_HostBindingHandler() {
          return ctx.transition$();
        })("$.style.transform", function TuiUnderlineComponent___style_transform_HostBindingHandler() {
          return ctx.transform$();
        })("$.style.width.px", function TuiUnderlineComponent___style_width_px_HostBindingHandler() {
          return ctx.width$();
        });
      }
    },
    inputs: {
      element: "element"
    },
    features: [i0.ɵɵProvidersFeature([MODE_PROVIDER])],
    decls: 0,
    vars: 0,
    template: function TuiUnderlineComponent_Template(rf, ctx) {},
    styles: ["[_nghost-%COMP%]{transition-property:none;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;position:absolute;left:0;height:100%;color:var(--tui-primary);transform:scale(0);box-shadow:inset 0 -.1875rem 0 -.0625rem;pointer-events:none}[data-mode=onDark][_nghost-%COMP%]{color:var(--tui-text-01-night)}[data-mode=onLight][_nghost-%COMP%]{color:var(--tui-text-02)}"],
    changeDetection: 0
  });
  return TuiUnderlineComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class TuiTabsComponent {
  constructor(options, el, tabs, cdr, resize$) {
    this.options = options;
    this.el = el;
    this.tabs = tabs;
    this.children = EMPTY_QUERY;
    this.underline = this.options.underline;
    resize$.pipe(filter(() => this.underline)).subscribe(() => {
      cdr.detectChanges();
    });
  }
  /** @deprecated use `activeItemIndex` from {@link TuiTabsDirective} instead */
  get activeItemIndex() {
    return this.tabs.activeItemIndex;
  }
  /** @deprecated use `activeItemIndex` from {@link TuiTabsDirective} instead */
  set activeItemIndex(index) {
    this.tabs.activeItemIndex = index;
  }
  get activeElement() {
    return this.tabs.activeElement;
  }
  onKeyDownArrow(current, step) {
    this.tabs.moveFocus(current, step);
  }
  ngAfterViewChecked() {
    this.scrollTo(this.tabs.activeItemIndex);
  }
  scrollTo(index) {
    const element = this.tabs.tabs[index];
    if (!element) {
      return;
    }
    const {
      offsetLeft,
      offsetWidth
    } = element;
    const {
      nativeElement
    } = this.el;
    if (offsetLeft < nativeElement.scrollLeft) {
      nativeElement.scrollLeft = offsetLeft;
    }
    if (offsetLeft + offsetWidth > nativeElement.scrollLeft + nativeElement.offsetWidth) {
      nativeElement.scrollLeft = offsetLeft + offsetWidth - nativeElement.offsetWidth;
    }
  }
}
TuiTabsComponent.ɵfac = function TuiTabsComponent_Factory(t) {
  return new (t || TuiTabsComponent)(i0.ɵɵdirectiveInject(TUI_TABS_OPTIONS), i0.ɵɵdirectiveInject(ElementRef), i0.ɵɵdirectiveInject(TuiTabsDirective), i0.ɵɵdirectiveInject(ChangeDetectorRef), i0.ɵɵdirectiveInject(TuiResizeService));
};
TuiTabsComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
  type: TuiTabsComponent,
  selectors: [["tui-tabs", 3, "vertical", ""], ["nav", "tuiTabs", "", 3, "vertical", ""]],
  contentQueries: function TuiTabsComponent_ContentQueries(rf, ctx, dirIndex) {
    if (rf & 1) {
      i0.ɵɵcontentQuery(dirIndex, TuiTabComponent, 4);
    }
    if (rf & 2) {
      let _t;
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.children = _t);
    }
  },
  hostVars: 2,
  hostBindings: function TuiTabsComponent_HostBindings(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵlistener("keydown.arrowRight.prevent", function TuiTabsComponent_keydown_arrowRight_prevent_HostBindingHandler($event) {
        return ctx.onKeyDownArrow($event.target, 1);
      })("keydown.arrowLeft.prevent", function TuiTabsComponent_keydown_arrowLeft_prevent_HostBindingHandler($event) {
        return ctx.onKeyDownArrow($event.target, -1);
      });
    }
    if (rf & 2) {
      i0.ɵɵclassProp("_underline", ctx.underline);
    }
  },
  inputs: {
    underline: "underline"
  },
  features: [i0.ɵɵProvidersFeature([TuiDestroyService, TuiResizeService, MutationObserverService, {
    provide: MUTATION_OBSERVER_INIT,
    useValue: {
      childList: true
    }
  }])],
  ngContentSelectors: _c1,
  decls: 4,
  vars: 4,
  consts: [[4, "ngIf"], ["class", "t-underline", 3, "element", 4, "ngIf"], [1, "t-underline", 3, "element"]],
  template: function TuiTabsComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵtemplate(0, TuiTabsComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
      i0.ɵɵpipe(1, "async");
      i0.ɵɵprojection(2);
      i0.ɵɵtemplate(3, TuiTabsComponent_tui_underline_3_Template, 1, 1, "tui-underline", 1);
    }
    if (rf & 2) {
      i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx.children.changes));
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("ngIf", ctx.underline);
    }
  },
  dependencies: [TuiUnderlineComponent, i5.NgIf, i5.AsyncPipe],
  styles: ["[_nghost-%COMP%]{scrollbar-width:none;-ms-overflow-style:none;position:relative;display:flex;font:var(--tui-font-text-m);height:var(--tui-height-l);color:var(--tui-text-02);box-shadow:inset 0 -1px var(--tui-base-03);overflow:auto;isolation:isolate}[_nghost-%COMP%]::-webkit-scrollbar, [_nghost-%COMP%]::-webkit-scrollbar-thumb{background:transparent;width:0;height:0}.t-underline[_ngcontent-%COMP%]{z-index:-1}"],
  changeDetection: 0
});
__decorate([tuiPure], TuiTabsComponent.prototype, "scrollTo", null);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiTabsVerticalComponent = /*#__PURE__*/(() => {
  class TuiTabsVerticalComponent {
    constructor(tabs) {
      this.tabs = tabs;
      this.vertical = 'left';
    }
    onKeyDownArrow(current, step) {
      this.tabs.moveFocus(current, step);
    }
  }
  TuiTabsVerticalComponent.ɵfac = function TuiTabsVerticalComponent_Factory(t) {
    return new (t || TuiTabsVerticalComponent)(i0.ɵɵdirectiveInject(TuiTabsDirective));
  };
  TuiTabsVerticalComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TuiTabsVerticalComponent,
    selectors: [["tui-tabs", "vertical", ""], ["nav", "tuiTabs", "", "vertical", ""]],
    hostVars: 1,
    hostBindings: function TuiTabsVerticalComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("keydown.arrowDown.prevent", function TuiTabsVerticalComponent_keydown_arrowDown_prevent_HostBindingHandler($event) {
          return ctx.onKeyDownArrow($event.target, 1);
        })("keydown.arrowUp.prevent", function TuiTabsVerticalComponent_keydown_arrowUp_prevent_HostBindingHandler($event) {
          return ctx.onKeyDownArrow($event.target, -1);
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("data-vertical", ctx.vertical);
      }
    },
    inputs: {
      vertical: "vertical"
    },
    attrs: _c2,
    ngContentSelectors: _c1,
    decls: 1,
    vars: 0,
    template: function TuiTabsVerticalComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;font:var(--tui-font-text-m);color:var(--tui-text-02);box-shadow:inset -1px 0 var(--tui-base-03)}[data-vertical=right][_nghost-%COMP%]{box-shadow:inset 1px 0 var(--tui-base-03)}"],
    changeDetection: 0
  });
  return TuiTabsVerticalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const TUI_TABS_REFRESH = new InjectionToken(`[TUI_TABS_REFRESH]`);
const TUI_TABS_PROVIDERS = [TuiResizeService, TuiDestroyService, MutationObserverService, tuiDropdownOptionsProvider({
  align: `right`
}), {
  provide: MUTATION_OBSERVER_INIT,
  useValue: {
    childList: true,
    subtree: true,
    characterData: true
  }
}, {
  provide: TUI_TABS_REFRESH,
  deps: [TuiResizeService, MutationObserverService, TuiDestroyService, DOCUMENT, ElementRef, ChangeDetectorRef],
  useFactory: (resize$, mutations$, destroy$, {
    body
  }, {
    nativeElement
  }, cdr) => merge(resize$, mutations$.pipe(tap(() => cdr.detectChanges()))).pipe(
  // Ignoring cases when host is detached from DOM
  filter(() => body.contains(nativeElement)), debounceTime(0), startWith(null), takeUntil(destroy$))
}];
let TuiTabsWithMoreComponent = /*#__PURE__*/(() => {
  class TuiTabsWithMoreComponent {
    constructor(options, margin, refresh$, el, cdr, moreWord$, arrowOptions) {
      this.options = options;
      this.margin = margin;
      this.refresh$ = refresh$;
      this.el = el;
      this.cdr = cdr;
      this.moreWord$ = moreWord$;
      this.arrowOptions = arrowOptions;
      this.maxIndex = Infinity;
      this.underline = this.options.underline;
      this.itemsLimit = this.options.itemsLimit;
      this.activeItemIndexChange = new EventEmitter();
      this.items = EMPTY_QUERY;
      this.activeItemIndex = 0;
      this.open = false;
    }
    set itemIndex(activeItemIndex) {
      this.activeItemIndex = activeItemIndex;
      this.maxIndex = this.getMaxIndex();
    }
    // TODO: Improve performance
    get tabs() {
      return Array.from(this.el.nativeElement.querySelectorAll('[tuiTab]'));
    }
    get activeElement() {
      var _a;
      const {
        tabs
      } = this;
      const safeActiveIndex = tuiClamp(this.activeItemIndex || 0, 0, tabs.length - 2);
      return this.options.exposeActive || this.lastVisibleIndex >= safeActiveIndex ? tabs[safeActiveIndex] || null : ((_a = this.moreButton) === null || _a === void 0 ? void 0 : _a.nativeElement) || null;
    }
    get isMoreAlone() {
      return this.lastVisibleIndex < 0 && !this.options.exposeActive;
    }
    get isMoreVisible() {
      return this.lastVisibleIndex < this.items.length - 1;
    }
    get isMoreFocusable() {
      return !!this.moreButton && tuiIsNativeFocused(this.moreButton.nativeElement);
    }
    get isMoreActive() {
      return this.open || !this.options.exposeActive && this.lastVisibleIndex < this.activeItemIndex;
    }
    get lastVisibleIndex() {
      if (this.itemsLimit + 1 >= this.items.length) {
        return this.maxIndex;
      }
      const offset = this.itemsLimit - 1 > this.activeItemIndex || !this.options.exposeActive ? 1 : 2;
      return Math.min(this.itemsLimit - offset, this.maxIndex);
    }
    ngAfterViewInit() {
      this.refresh$.pipe(map(() => this.getMaxIndex()), filter(maxIndex => this.maxIndex !== maxIndex)).subscribe(maxIndex => {
        this.maxIndex = maxIndex;
        this.cdr.detectChanges();
      });
    }
    onActiveItemIndexChange(activeItemIndex) {
      this.updateActiveItemIndex(activeItemIndex);
    }
    onClick(index) {
      this.open = false;
      this.focusMore();
      this.updateActiveItemIndex(index);
    }
    onArrowRight(event) {
      if (tuiIsElement(event.target) && tuiIsNativeFocused(event.target)) {
        this.focusMore();
      }
    }
    onArrowLeft() {
      const {
        tabs
      } = this;
      let index = tabs.length - 2;
      while (index >= 0) {
        tabs[index].focus();
        if (tuiIsNativeFocused(tabs[index])) {
          return;
        }
        index--;
      }
    }
    onWrapperArrow(event, wrapper, previous) {
      const button = event.target;
      const target = tuiGetClosestFocusable({
        initial: button,
        root: wrapper,
        previous
      });
      if (target) {
        target.focus();
      }
    }
    isOverflown(index) {
      return index !== this.activeItemIndex || !this.options.exposeActive;
    }
    shouldShow(index) {
      return index > this.lastVisibleIndex && this.isOverflown(index);
    }
    focusMore() {
      if (this.moreButton) {
        this.moreButton.nativeElement.focus();
      }
    }
    getMaxIndex() {
      const {
        tabs,
        activeItemIndex,
        margin
      } = this;
      if (tabs.length < 2) {
        return 0;
      }
      const {
        exposeActive,
        minMoreWidth
      } = this.options;
      const {
        clientWidth
      } = this.el.nativeElement;
      const activeWidth = tabs[activeItemIndex] ? tabs[activeItemIndex].scrollWidth : 0;
      const moreWidth = Math.max(tabs[tabs.length - 1].scrollWidth, minMoreWidth);
      let maxIndex = tabs.length - 2;
      let total = tabs.reduce((acc, {
        scrollWidth
      }) => acc + scrollWidth, 0) + maxIndex * margin - tabs[tabs.length - 1].scrollWidth;
      if (total <= clientWidth) {
        return Infinity;
      }
      while (maxIndex) {
        total -= tabs[maxIndex].scrollWidth + margin;
        maxIndex--;
        const activeDisplaced = exposeActive && activeItemIndex > maxIndex;
        const activeOffset = activeDisplaced ? activeWidth + margin : 0;
        const currentWidth = total + activeOffset + moreWidth + margin;
        // Needed for different rounding of visible and hidden elements scrollWidth
        const safetyOffset = tuiToInt(this.maxIndex === maxIndex - 1);
        if (currentWidth + safetyOffset < clientWidth) {
          return maxIndex;
        }
      }
      return -1;
    }
    updateActiveItemIndex(activeItemIndex) {
      this.itemIndex = activeItemIndex;
      this.activeItemIndexChange.emit(activeItemIndex);
    }
  }
  TuiTabsWithMoreComponent.ɵfac = function TuiTabsWithMoreComponent_Factory(t) {
    return new (t || TuiTabsWithMoreComponent)(i0.ɵɵdirectiveInject(TUI_TABS_OPTIONS), i0.ɵɵdirectiveInject(TUI_TAB_MARGIN), i0.ɵɵdirectiveInject(TUI_TABS_REFRESH), i0.ɵɵdirectiveInject(ElementRef), i0.ɵɵdirectiveInject(ChangeDetectorRef), i0.ɵɵdirectiveInject(TUI_MORE_WORD), i0.ɵɵdirectiveInject(TUI_ARROW_OPTIONS));
  };
  TuiTabsWithMoreComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TuiTabsWithMoreComponent,
    selectors: [["tui-tabs-with-more"], ["nav", "tuiTabsWithMore", ""]],
    contentQueries: function TuiTabsWithMoreComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, TuiItemDirective, 4, TemplateRef);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.items = _t);
      }
    },
    viewQuery: function TuiTabsWithMoreComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(TuiTabComponent, 5, ElementRef);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.moreButton = _t.first);
      }
    },
    hostVars: 2,
    hostBindings: function TuiTabsWithMoreComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassProp("_underline", ctx.underline);
      }
    },
    inputs: {
      moreContent: "moreContent",
      dropdownContent: "dropdownContent",
      underline: "underline",
      itemIndex: ["activeItemIndex", "itemIndex"],
      itemsLimit: "itemsLimit"
    },
    outputs: {
      activeItemIndexChange: "activeItemIndexChange"
    },
    features: [i0.ɵɵProvidersFeature(TUI_TABS_PROVIDERS)],
    decls: 13,
    vars: 17,
    consts: [[4, "ngIf"], [1, "t-wrapper"], [1, "t-tabs", 3, "activeItemIndex", "underline", "activeItemIndexChange", "keydown.arrowRight"], [4, "ngFor", "ngForOf"], [1, "t-more_wrapper", 3, "content", "open", "openChange"], ["tuiTab", "", 3, "tuiFocusable", "keydown.arrowLeft.prevent"], [4, "polymorpheusOutlet"], ["more", ""], ["dropdown", ""], [3, "element", 4, "ngIf"], [3, "ngTemplateOutlet", 4, "ngIf", "ngIfElse"], ["hidden", ""], [3, "ngTemplateOutlet"], [1, "t-icon", 3, "src"], [1, "t-dropdown", 3, "keydown.arrowDown.prevent", "keydown.arrowUp.prevent"], ["element", ""], [3, "tui-tab-activate", 4, "ngFor", "ngForOf"], [3, "tui-tab-activate"], [3, "ngTemplateOutlet", 4, "ngIf"], [3, "element"]],
    template: function TuiTabsWithMoreComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, TuiTabsWithMoreComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵelementStart(2, "div", 1)(3, "tui-tabs", 2);
        i0.ɵɵlistener("activeItemIndexChange", function TuiTabsWithMoreComponent_Template_tui_tabs_activeItemIndexChange_3_listener($event) {
          return ctx.onActiveItemIndexChange($event);
        })("keydown.arrowRight", function TuiTabsWithMoreComponent_Template_tui_tabs_keydown_arrowRight_3_listener($event) {
          return ctx.onArrowRight($event);
        });
        i0.ɵɵtemplate(4, TuiTabsWithMoreComponent_ng_container_4_Template, 4, 2, "ng-container", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "tui-hosted-dropdown", 4);
        i0.ɵɵlistener("openChange", function TuiTabsWithMoreComponent_Template_tui_hosted_dropdown_openChange_5_listener($event) {
          return ctx.open = $event;
        });
        i0.ɵɵelementStart(6, "button", 5);
        i0.ɵɵlistener("keydown.arrowLeft.prevent", function TuiTabsWithMoreComponent_Template_button_keydown_arrowLeft_prevent_6_listener() {
          return ctx.onArrowLeft();
        });
        i0.ɵɵtemplate(7, TuiTabsWithMoreComponent_ng_container_7_Template, 2, 1, "ng-container", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, TuiTabsWithMoreComponent_ng_template_8_Template, 3, 6, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, TuiTabsWithMoreComponent_ng_template_10_Template, 3, 1, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor)(12, TuiTabsWithMoreComponent_tui_underline_12_Template, 1, 1, "tui-underline", 9);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        const _r4 = i0.ɵɵreference(9);
        const _r6 = i0.ɵɵreference(11);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 15, ctx.items.changes));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("activeItemIndex", ctx.activeItemIndex)("underline", false);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.items);
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("t-overflown", !ctx.isMoreVisible);
        i0.ɵɵproperty("content", ctx.dropdownContent || _r6)("open", ctx.open);
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("_active", ctx.isMoreActive)("t-no-margin", ctx.isMoreAlone);
        i0.ɵɵproperty("tuiFocusable", ctx.isMoreFocusable);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("polymorpheusOutlet", ctx.moreContent || _r4);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.underline);
      }
    },
    dependencies: [TuiTabsComponent, i2$1.TuiHostedDropdownComponent, TuiTabComponent, i2$1.TuiSvgComponent, TuiUnderlineComponent, i5.NgIf, TuiTabsDirective, i5.NgForOf, i5.NgTemplateOutlet, i4.TuiFocusableDirective, i8.PolymorpheusOutletDirective, i5.AsyncPipe],
    styles: ["[_nghost-%COMP%]{position:relative;display:flex;font:var(--tui-font-text-m);height:var(--tui-height-l);box-sizing:border-box;color:var(--tui-text-02);box-shadow:inset 0 -1px var(--tui-base-03);overflow:hidden}.t-wrapper[_ngcontent-%COMP%]{position:relative;display:flex}.t-tabs[_ngcontent-%COMP%]{height:inherit;font-size:inherit;font-weight:inherit;overflow:visible;box-shadow:none;color:inherit}.t-overflown[_ngcontent-%COMP%]{display:flex;margin:0;width:0;max-width:0;overflow:hidden;visibility:hidden}.t-more_wrapper[_ngcontent-%COMP%]{height:100%;pointer-events:none}.t-more_wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{pointer-events:auto}.t-icon[_ngcontent-%COMP%]{transition-property:transform;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;margin-right:-.25rem;vertical-align:bottom}.t-icon_rotated[_ngcontent-%COMP%]{transform:rotate(180deg)}.t-dropdown[_ngcontent-%COMP%]{padding:.25rem 0}.t-dropdown[_ngcontent-%COMP%]     *[tuiTab]{width:calc(100% - .75rem);height:2.75rem;justify-content:flex-start;margin:.125rem .375rem;padding:0 .625rem;border-radius:var(--tui-radius-s);font:var(--tui-font-text-m);color:var(--tui-text-01)}.t-dropdown[_ngcontent-%COMP%]     *[tuiTab]:before{display:none}.t-dropdown[_ngcontent-%COMP%]     *[tuiTab]:hover, .t-dropdown[_ngcontent-%COMP%]     *[tuiTab]:focus, .t-dropdown[_ngcontent-%COMP%]     *[tuiTab]._active{box-shadow:none;background:var(--tui-clear)}.t-no-margin[_ngcontent-%COMP%]{margin-left:0}"],
    changeDetection: 0
  });
  return TuiTabsWithMoreComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiTabsModule = /*#__PURE__*/(() => {
  class TuiTabsModule {}
  TuiTabsModule.ɵfac = function TuiTabsModule_Factory(t) {
    return new (t || TuiTabsModule)();
  };
  TuiTabsModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: TuiTabsModule
  });
  TuiTabsModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule, PolymorpheusModule, TuiHostedDropdownModule, TuiSvgModule, TuiFocusableModule, TuiItemModule]]
  });
  return TuiTabsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_TABS_DEFAULT_OPTIONS, TUI_TABS_OPTIONS, TUI_TABS_PROVIDERS, TUI_TABS_REFRESH, TUI_TAB_ACTIVATE, TUI_TAB_EVENT, TUI_TAB_PROVIDERS, TuiTabComponent, TuiTabsComponent, TuiTabsDirective, TuiTabsModule, TuiTabsVerticalComponent, TuiTabsWithMoreComponent, TuiUnderlineComponent, tuiTabsOptionsProvider };
